import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { WorkspaceAvatar } from "@components/avatar/WorkspaceAvatar";
import { memo } from "react";
import {
    useTaskClientIconColor,
    useTaskClientName,
} from "../../taskClientNamesContext";
import { NestedTaskRow } from "../../types";
import { GroupClientsSummary } from "./TaskGroupSummaryCells";
import styles from "./TaskViewCells.module.scss";

export const ClientCell = memo(
    (props: CellContext<ViewTableFeatures, NestedTaskRow, string>) => {
        const { row } = props;
        const clientName = useTaskClientName(row.original.workspaceId);
        const iconColor = useTaskClientIconColor(row.original.workspaceId);

        if (row.original.isGroup) {
            return <GroupClientsSummary {...props} />;
        }

        if (row.original.isNewPlaceholder) {
            return null;
        }

        if (!clientName) {
            return <ViewTableCell>-</ViewTableCell>;
        }

        const workspace = { name: clientName, iconColor };

        return (
            <ViewTableCell className={styles.clientCell}>
                <WorkspaceAvatar workspace={workspace} aria-hidden />
                <span className={styles.clientName}>{clientName}</span>
            </ViewTableCell>
        );
    },
);
